import InputAdornment from '@material-ui/core/InputAdornment'
import styled from 'styled-components'

const Adorment = styled(InputAdornment)`
  font-size: 14px;
  line-height: 14px;
`

export default Adorment
